import React, { useEffect, useState } from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Loader from 'components/loader/Loader';
import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
import CommonTable from 'components/commonTable/CommonTable';

const AllRidesTabList = (props) => {
  const location = useLocation();
  const { state } = location;
  const {
    reservationList,
    handleDialog,
    handleTab,
    handleOperation,
    tableOnClickRow,
    onSearchQuery,
    onSelectDateRange,
    onClickMoreIcon,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    tab,
    accessForOperations,
    accessForReallot,
    accessForCancel,
    accessForAllotAndCancel,
    viewMoreIcon,
    onMarkNoShow,
  } = props;
  const [value, setValue] = useState('all');
  const bookingLoader = useSelector((state) => state?.getReservationList?.loading);

  useEffect(() => {
    if (state && state?.value) {
      setValue(state?.value);
    } else {
      setValue('all');
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    handleTab(newValue);
  };

  const tableProps = {
    isClickable: true,
    page: page,
    rowsPerPage: rowsPerPage,
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    tableOnClickRow: tableOnClickRow,
    data: reservationList,
    handleDialog: handleDialog,
    handleOperation: handleOperation,
    tabName: 'operation',
    onClickMoreIcon: onClickMoreIcon,
    accessForOperations,
    accessForReallot,
    accessForCancel: accessForCancel,
    accessForAllotAndCancel,
    viewMoreIcon: !viewMoreIcon,
    enableTripHighlight: true,
    showDispatchLegend: true,
    onMarkNoShow: onMarkNoShow,
  };

  const subHeaderProps = {
    filter: true,
    filterData: props.filterData,
    buttonName: '',
    onSelectDateRange: onSelectDateRange,
    onSearchQuery: onSearchQuery,
    onFilterChange: props.onFilterChange,
    onRestFilter: props?.onRestFilter,
    defaultStatus: props?.defaultStatus,
    defaultLocation: props?.defaultLocation,
    dateFrom: props?.dateFrom,
    dateTo: props?.dateTo,
    search: props?.search,
  };

  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={tab}>
            <Grid
              container
              className="tabBoxStyle justifyBetween flexRow"
              sx={{ width: '100%', overflow: 'hidden' }}
            >
              <Grid
                item
                sx={{
                  width: '100%',
                  overflowX: 'auto',
                  overflowY: 'hidden',
                  scrollBehavior: 'smooth',
                  msOverflowStyle: 'none',
                  scrollbarWidth: 'none',
                  '&::-webkit-scrollbar': { display: 'none' },
                }}
              >
                <TabList
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' },
                  }}
                  sx={{
                    minWidth: 'fit-content',
                    '& .MuiTabs-flexContainer': {
                      flexWrap: 'nowrap',
                    },
                    '& .MuiTab-root': {
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <Tab label="All" value="all" className="tabStyle" />
                  <Tab label="Booked" value="booked" className="tabStyle" />
                  <Tab label="Closed" value="closed" className="tabStyle" />
                  <Tab label="Completed" value="completed" className="tabStyle" />
                  <Tab label="Cancelled" value="cancelled" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <Box className="dashedBorder mt30 mb20"></Box>
            <TabPanel
              value="all"
              sx={{ width: '100%', p: 0, overflow: 'hidden' }}
              className="allRidesTable"
            >
              <Box className="mb20" sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box className="pb10">
                  <CommonSubHeader {...subHeaderProps} />
                </Box>
                {bookingLoader ? <Loader height={'65vh'} /> : <CommonTable {...tableProps} />}
              </Box>
            </TabPanel>
            <TabPanel value="booked" sx={{ width: '100%', p: 0, overflow: 'hidden' }}>
              <Box className="mb20" sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box className="pb10">
                  <CommonSubHeader {...subHeaderProps} />
                </Box>
                {bookingLoader ? <Loader height={'65vh'} /> : <CommonTable {...tableProps} />}
              </Box>
            </TabPanel>
            <TabPanel value="closed" sx={{ width: '100%', p: 0, overflow: 'hidden' }}>
              <Box className="mb20" sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box className="pb10">
                  <CommonSubHeader {...subHeaderProps} />
                </Box>
                {bookingLoader ? <Loader height={'65vh'} /> : <CommonTable {...tableProps} />}
              </Box>
            </TabPanel>
            <TabPanel value="completed" sx={{ width: '100%', p: 0, overflow: 'hidden' }}>
              <Box className="mb20" sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box className="pb10">
                  <CommonSubHeader {...subHeaderProps} />
                </Box>
                {bookingLoader ? <Loader height={'65vh'} /> : <CommonTable {...tableProps} />}
              </Box>
            </TabPanel>
            <TabPanel value="cancelled" sx={{ width: '100%', p: 0, overflow: 'hidden' }}>
              <Box className="mb20" sx={{ width: '100%', overflowX: 'hidden' }}>
                <Box className="pb10">
                  <CommonSubHeader {...subHeaderProps} />
                </Box>
                {bookingLoader ? <Loader height={'65vh'} /> : <CommonTable {...tableProps} />}
              </Box>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AllRidesTabList;
